var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.$route.meta.hideTopbar)?_c('Topbar'):_vm._e(),_c('AppMain'),(!_vm.$route.meta.hideTopbar)?_c('Playbar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }